module.exports = __webpack_public_path__ + "img/home_fahrradgarage_secanda_pc.fee7f2e0.jpg";